import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import CollectionBaseAdminView from "./CollectionBaseAdminView";
import StagesManager from "../../components/StagesManager";
import Cookies from "universal-cookie";
import { chooseFontColor } from "../../utils/useful";
import { DeskFrames } from "../../variables/AppletPages";
import PageStatusViewer from "../../components/PageStatusViewer";
import CollectionBaseUserView from "./CollectionBaseUserView";

class DeskApplet extends Component {

    state = {

        headerConfig: {
            showToolbar: true, showSettings: true, showSettings: true, showFrames: 'desk', type: 'desk', isPortal: this.props.isPortal, title: this.props.isPortal ? '{{lang}}Desk Portal' : null, frames: []
        },
        colors: {
            primaryColor: '#184D94',
            secondaryColor: '#246AC7',
            textColor: '#fff'
        },
        headers: [
            { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}Title', inplaceEditable: false, placeholder: '{{lang}}desk.insert', required: false }, showMain: true },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}Description', inplaceEditable: false, placeholder: '{{lang}}desk.insert', required: false }, showMain: false },
            { key: 'parent', type: 'SelectInput', information: { label: '{{lang}}parent', address: 'getMyTasks', filter: { applet: '{{appletId}}' }, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: false, disabled: true }, showMain: false },
            { key: 'timeline.dueDate', type: 'DateInput', col: '12', information: { label: '{{lang}}desk.Due Date', inplaceEditable: false, placeholder: '{{lang}}desk.Date', required: false }, showMain: true },
            { key: 'categorizer', type: 'CategorizerInput', fullCol: true, information: { label: '{{lang}}Categorizer', inplaceEditable: false, required: false, type: 'api', address: 'getInputOptions', fields: { title: 'label', value: '_id', parent: 'parent', colors: 'colors' }, filter: { applet: '{{appletId}}', frame: '{{frameId}}', appletHub: '{{appletHub}}' }, }, showMain: true, inExport: true },
            { key: 'priority', type: 'StatusSelectInput', inPlaceEdit: true, information: { label: '{{lang}}desk.priority', inplaceEditable: false, placeholder: '{{lang}}desk.priority', items: [{ label: '{{lang}}desk.High', key: 'high', color: '#fff', bgColor: '#CA5C72' }, { label: '{{lang}}desk.Medium', key: 'medium', color: '#fff', bgColor: '#f5b00f' }, { label: '{{lang}}desk.Low', key: 'low', color: '#fff', bgColor: '#20c676' }], required: false } },
            { key: 'assignee', type: 'GlobalUserInput', information: { label: '{{lang}}Assignee', inplaceEditable: false, address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}desk.select', required: false, } },
            { key: 'collaborators', type: 'GlobalUserMultiInput', information: { label: '{{lang}}Collaborators', inplaceEditable: false, address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}desk.select', required: false, } },
            // { key: 'test', type: 'LookupInput', information: { label: '{{lang}}test', inplaceEditable: false, address: 'getFrames', filter: {}, fields: { title: 'name', collection: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}desk.select', required: false, } },
            // { key: 'frame', type: 'FrameSelector', information: { label: '{{lang}}frame', inplaceEditable: false, address: 'getFrames', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}desk.select', required: false, } },
        ],
    }

    componentDidMount() {
        const cookies = new Cookies();
        let token = cookies.get('token');
        if (token) {
            this.setState({ isLoading: true })
            this.waitForId(10)
        } else {
            this.setState({ pageStatus: 401 })
            return
        }
        let framesSections = Object.values(DeskFrames.sections)
        let frames = []
        if (Array.isArray(this.props.frames)) {
            this.props.frames.forEach(mframe => {
                let element = mframe
                if (element) {
                    if (mframe?.type == 'page' || mframe?.type == 'project') {
                        element.key = element._id
                        element.section = 'pages'
                        element.pageType = 'page'
                        element.fetchUrl = 'getRecords'
                        element.addUrl = 'postRecord'
                        element.editUrl = 'postRecord'
                        element.removeUrl = 'removeRecord'
                        element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{frameId}}' }
                        element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}' }
                        // element.fields = this.state.headers
                        frames.push(element)
                    }
                    else if (mframe?.type == 'recordClassifier') {
                        element.key = element._id
                        element.section = 'pages'
                        element.pageType = 'classifier'
                        element.fetchUrl = 'getMyTasks'
                        element.addUrl = 'postRecord'
                        element.editUrl = 'postRecord'
                        element.removeUrl = 'removeRecord'
                        element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{frameId}}' }
                        element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}' }
                        element.fields.forEach(field => {
                            field.key = field.key
                        });
                        frames.push(element)
                    }
                    else {
                        element.key = element._id
                        element.section = 'collections'
                        element.pageType = 'collection'
                        element.fetchUrl = 'getMyTasks'
                        element.addUrl = 'addTask'
                        element.editUrl = 'updateTask'
                        element.removeUrl = 'removeTask'
                        element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{frameId}}' }
                        element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{appletId}}' }
                        // element.fields = this.state.headers
                        frames.push(element)
                    }
                }
            });
        }
        frames = [...frames, ...Object.values(DeskFrames.pages)]
        this.init()
        this.setState({ frames, framesSections })
    }

    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {
            this.setState({ pageStatus: 200 }, () => {
                this.checkDefaultTab()
            })
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                    this.setState({ pageStatus: 401, hasToken: false })
                }
            }, 500)
        }
    }
    init = () => {
        let headerConfig = this.state.headerConfig
        headerConfig.frames = this.props.frames
        this.setState({ headerConfig })
    }

    componentDidUpdate(prevProps) {
        if ((JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path))) {
            this.setState({ oldData: this.props.windowData }, () => {
                this.checkDefaultTab()
            })
        }
        if (this.props.frames && JSON.stringify(this.props.frames) != JSON.stringify(prevProps.frames)) {
            let frames = []
            if (Array.isArray(this.props.frames)) {
                this.props.frames.forEach(mframe => {
                    let element = mframe
                    if (element) {
                        if (mframe?.type == 'page') {
                            element.key = element._id
                            element.section = 'pages'
                            element.pageType = 'page'
                            element.fetchUrl = 'getRecords'
                            element.addUrl = 'postRecord'
                            element.editUrl = 'postRecord'
                            element.removeUrl = 'removeRecord'
                            element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{frameId}}' }
                            element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}' }
                            // element.fields = this.state.headers
                            frames.push(element)
                        }
                        else if (mframe?.type == 'recordClassifier') {
                            element.key = element._id
                            element.section = 'pages'
                            element.pageType = 'classifier'
                            element.fetchUrl = 'getMyTasks'
                            element.addUrl = 'postRecord'
                            element.editUrl = 'postRecord'
                            element.removeUrl = 'removeRecord'
                            element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{frameId}}' }
                            element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}' }
                            element.fields.forEach(field => {
                                field.key = field.key
                            });
                            frames.push(element)
                        }
                        else {
                            element.key = element._id
                            element.section = 'collections'
                            element.pageType = 'collection'
                            element.fetchUrl = 'getMyTasks'
                            element.addUrl = 'addTask'
                            element.editUrl = 'updateTask'
                            element.removeUrl = 'removeTask'
                            element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{frameId}}' }
                            element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{appletId}}' }
                            // element.fields = this.state.headers
                            frames.push(element)
                        }
                    }
                });
            }
            frames = [...frames, ...Object.values(DeskFrames.pages)]
            let headerConfig = this.state.headerConfig
            headerConfig.frames = this.props.frames
            this.setState({ headerConfig, frames })
        }
    }

    checkDefaultTab() {


        // console.log("checkDefaultTab")
        let def = ''
        let pageType = null
        let pathname = this.props.windowData.path//window.location.pathname.split('/')

        let rootRef = this.props.route.split('/')
        // console.log('rootRefd', this.props.route)
        // console.log('pathnamedatabase', pathname)

        rootRef = rootRef[rootRef.length - 1]

        let pageIsValid = false
        if (rootRef.includes('admin') || pathname.includes('admin')) {
            def = 'admin'
            pageType = 'admin'
            pageIsValid = true
        }
        // console.log(def)
        // console.log(rootRef)
        // console.log(pathname)


        if (!def) {
            def = ''
        }

        console.log(def)




        if (def === '') {
            pageType = ''
            pageIsValid = true

        }
        if (pageIsValid) {

            // console.log('page', pageType, def);
            this.setState({ oldData: this.props.windowData }, () => {


                this.setState({ path: def, pageType }, () => {
                    // console.log(pageType) 


                    setTimeout(() => {
                        this.setState({ page: null }, () => {
                            // console.log(pageInfo)
                            this.setState({ pageType, pageStatus: 200 }, () => {
                                if (this.stageManager) {
                                    this.stageManager.changeStage((pageType), () => {
                                        // this.pageContainer.scrollTo({ top: 0, behavior: 'smooth' })
                                    })
                                } else {

                                }
                            })
                        })
                    }, 10);
                })

                // return
            })
        } else {
            this.setState({ pageStatus: 404 })
        }

    }


    // checkDefaultTab() {
    //     let def = ''
    //     let pageType = null
    //     let pathname = this.props.windowData.path//window.location.pathname.split('/')
    //     let rootRef = this.props.route.split('/')
    //     rootRef = rootRef[rootRef.length - 1]
    //     let pageIsValid = false
    //     if (rootRef.includes('admin') || pathname.includes('admin')) {
    //         def = 'admin'
    //         pageType = 'admin'
    //         pageIsValid = true
    //     }
    //     if (!def) {
    //         def = ''
    //     }
    //     if (def === '') {
    //         pageType = ''
    //         pageIsValid = true
    //     }
    //     if (pageIsValid) {
    //         this.setState({ oldData: this.props.windowData }, () => {
    //             this.setState({ path: def, pageType }, () => {
    //                 setTimeout(() => {
    //                     this.setState({ page: null }, () => {
    //                         this.setState({ pageType, pageStatus: 200 }, () => {
    //                             if (this.stageManager) {
    //                                 this.stageManager.changeStage((pageType), () => {
    //                                 })
    //                             } else { }
    //                         })
    //                     })
    //                 }, 10);
    //             })
    //         })
    //     } else {
    //         this.setState({ pageStatus: 404 })
    //     }
    // }

    setData = (key, value, reference, cb) => {
        if (reference == 'CommerceApplet') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }

    updateFrames = (info) => {
        let frames = this.props.frames
        console.log('info', info)
        if (!Array.isArray(info)) {
            info = [info]
        }
        info.forEach(mframe => {
            let element = mframe
            if (element) {
                if (mframe?.type == 'page') {
                    element.key = element._id
                    element.section = 'pages'
                    element.pageType = 'page'
                    element.fetchUrl = 'getRecords'
                    element.addUrl = 'postRecord'
                    element.editUrl = 'postRecord'
                    element.removeUrl = 'removeRecord'
                    element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{frameId}}' }
                    element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}' }
                    // element.fields = this.state.headers
                    frames.push(element)
                }
                else if (mframe?.type == 'recordClassifier') {
                    element.key = element._id
                    element.section = 'pages'
                    element.pageType = 'classifier'
                    element.fetchUrl = 'getMyTasks'
                    element.addUrl = 'postRecord'
                    element.editUrl = 'postRecord'
                    element.removeUrl = 'removeRecord'
                    element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{frameId}}' }
                    element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}' }
                    element.fields.forEach(field => {
                        field.key = field.key
                    });
                    frames.push(element)
                }
                else {
                    element.key = element._id
                    element.section = 'collections'
                    element.pageType = 'collection'
                    element.fetchUrl = 'getMyTasks'
                    element.addUrl = 'addTask'
                    element.editUrl = 'updateTask'
                    element.removeUrl = 'removeTask'
                    element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{frameId}}' }
                    element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{appletId}}' }
                    // element.fields = this.state.headers
                    frames.push(element)
                }
            }
        });
        console.log('framesssssffflff', frames)
        this.setState({ frames })
    }



    render() {
        let colors = this.state.colors ?? {}
        let applet = this.props.applet
        if (applet?.colorType == 'sameAsHub') { }
        if (applet?.colorType == "custom") {
            colors = applet?.colors
        }
        if (!colors?.textColor) {
            colors.textColor = '#fff'
        }
        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false
        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`
        // console.log('this.props.appletAccess',this.props.appletAccess)
        return (
            <>
                {/* <PageStatusViewer status={this.state.pageStatus} isLoading={this.state.isLoading} applet={this.props.applet} colors={colors} addNewWindow={this.props.addNewWindow}> */}
                <div className=" w-100 h-100 window-content-radius " style={{ backgroundColor: '#F5F5F5' }}>
                    {/* {console.log('firstthis.state.frames',this.state.frames)} */}
                    <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}  >
                        <CollectionBaseAdminView appletAccess={this.props.appletAccess} updateFrames={this.updateFrames} isDesktop={this.props.isDesktop} isMobile={this.props.isMobile} permissions={this.props.permissions} setCurrentApplet={this.props.setCurrentApplet} type={'Tasking'} setData={this.setData} stageName={'admin'} baseUrl={[...this.props.baseUrl, 'admin']} isPortal={this.props.isPortal} frames={this.state.frames} mainFrames={this.props.frames} framesSections={this.state.framesSections} colors={colors} language={this.props.language} width={this.props.width} height={this.props.height} lastSelected={this.props.lastSelected} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} defaultHeaderConfig={this.state.headerConfig} />
                        <CollectionBaseUserView userView={true} stageName={''} baseUrl={[...this.props.baseUrl]} variables={this.props.variables} colors={colors} frames={this.state.frames} framesSections={this.state.framesSections} changeWindowLink={this.props.changeWindowLink} width={this.props.width} height={this.props.height}
                            windowData={this.props.windowData} route={this.props.rootUrl} applet={this.props.applet}
                            connection={this.props.connection} user={this.props.user} setUser={this.props.setUser}
                            addNotif={this.props.addNotif} history={this.props.history} location={this.props.location}
                            goToHub={this.props.goToHub} language={this.props.language} changeWindow={this.props.changeWindow} />
                    </StagesManager>
                </div>
                {/* </PageStatusViewer> */}
            </>
        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DeskApplet);